import axios from '../../axios'

const state = {
  user: JSON.parse(localStorage.getItem('user')) || null,
  token: localStorage.getItem('token') || null
}

const getters = {
  isAuthenticated: state => !!state.user,
  isAdmin: state => state.user && state.user.isAdmin,
  currentUser: state => state.user,
  companyCredits: state => {
    if (!state.user) return 0
    if (state.user.subscription_type === 'UNLIMITED') return 999999
    if (state.user.subscription_type === 'FREE') return state.user.daily_free_balance
    return state.user.credit_balance || 0
  },
  creditsDisplay: state => {
    if (!state.user) return '0'
    if (state.user.subscription_type === 'UNLIMITED') return 'Unlimited'
    if (state.user.subscription_type === 'UNLIMITED') return 'Unlimited'
    if (state.user.subscription_type === 'FREE') return `${state.user.daily_free_balance}/${state.user.daily_free_limit || 5} (Free)`
    return (state.user.credit_balance || 0).toString()
    return (state.user.credit_balance || 0).toString()
  }
}

const actions = {
  async login({ commit }, credentials) {
    try {
      const response = await axios.post('/api/auth/login', credentials, { withCredentials: true })
      const user = response.data.user

      commit('SET_USER', user)
      localStorage.setItem('user', JSON.stringify(user))

      return { success: true, user }
    } catch (error) {
      return { success: false, error: error.response ? error.response.data.error : 'Login failed' }
    }
  },

  async register({ commit }, userData) {
    try {
      const response = await axios.post('/api/auth/register', userData)
      return { success: true, message: response.data.message }
    } catch (error) {
      return { success: false, error: error.response ? error.response.data.error : 'Registration failed' }
    }
  },

  async logout({ commit }) {
    try {
      await axios.post('/api/auth/logout', {}, { withCredentials: true })
      commit('CLEAR_USER')
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      return { success: true }
    } catch (error) {
      return { success: false, error: 'Logout failed' }
    }
  },

  async fetchUser({ commit }) {
    try {
      const response = await axios.get('/api/auth/me', { withCredentials: true })
      if (response.data.success) {
        commit('SET_USER', response.data.user)
        localStorage.setItem('user', JSON.stringify(response.data.user))
        return { success: true, user: response.data.user }
      }
      return { success: false }
    } catch (error) {
      console.error('Error fetching user:', error)
      return { success: false, error: error.message }
    }
  },

  updateCredits({ commit }, credits) {
    commit('UPDATE_CREDITS', credits)
  }
}

const mutations = {
  SET_USER(state, user) {
    state.user = user
  },

  CLEAR_USER(state) {
    state.user = null
    state.token = null
  },

  UPDATE_CREDITS(state, payload) {
    if (state.user) {
      // Handle both legacy (number) and new (object) payloads
      if (typeof payload === 'number') {
        state.user.credit_balance = payload
        state.user.credits = payload // Legacy support
      } else if (typeof payload === 'object') {
        // Create new object to ensure reactivity
        state.user = {
          ...state.user,
          credit_balance: payload.credit_balance,
          subscription_type: payload.subscription_type,
          daily_free_balance: payload.daily_free_balance,
          daily_free_limit: payload.daily_free_limit || 5,
          last_reset_date: payload.last_reset_date || state.user.last_reset_date,
          // Legacy support
          credits: payload.credit_balance !== undefined ? payload.credit_balance : state.user.credits
        }
      }
      localStorage.setItem('user', JSON.stringify(state.user))
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}